import React from 'react';
import Badge from '@material-ui/core/Badge';
import MuiNotificationsIcon from '@material-ui/icons/Notifications';
import { useNotificationsIconStyles } from './notifications-styles';

export const NotificationsIcon = ({ count }: { count: number }) => {
  const cls = useNotificationsIconStyles();

  return (
    <Badge
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      color="primary"
      badgeContent={count}
    >
      <MuiNotificationsIcon className={cls.icon} />
    </Badge>
  );
};
